import { render } from "./PiniaCounterPage.vue?vue&type=template&id=33de1783&scoped=true"
import script from "./PiniaCounterPage.vue?vue&type=script&lang=js"
export * from "./PiniaCounterPage.vue?vue&type=script&lang=js"

import "./PiniaCounterPage.vue?vue&type=style&index=0&id=33de1783&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33de1783"]])

export default __exports__